export default __webpack_public_path__ + "documents/Parlor Membership.pdf";